<template>
    <ab-flow-base-cmp :movable="true" :block="block" class="sign-up-editor-cmp">

        <ab-flow-link-connector :block="block" type="input" class="ev-run" event="run"/>

        <q-card>

            <q-card-section class="bg-secondary text-white">
                Sign up: {{ provider }}
            </q-card-section>
        </q-card>

        <div class="results">
            <ab-flow-link-connector class="q-mt-sm" :block="block" type="output" event="success" key="success"/>
            <ab-flow-link-connector class="q-mt-sm" :block="block" type="output" event="error" key="error"/>
            <ab-flow-link-connector class="q-mt-sm" :block="block" type="output" event="user-exists" key="user-exists"/>
        </div>

    </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";

export default {
  components: { AbFlowBaseCmp, AbFlowLinkConnector},
  inject: ['canvas'],
  props: ['block'],
  name: "SignUpEditorCmp",

  computed: {
    provider() {
      return this.block?.properties?.provider || 'default';
    },
  },
}

</script>

<style lang="scss">

.sign-up-editor-cmp {
  .ev-run {
    left:-12px;
    position: absolute;
    top:calc(50% - 5px);
  }

  .results {
    position: absolute;
    right: -12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

</style>
